<!-- 同库调仓 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle" :ReturnUrl="'/inventoryManage/transSpaces'"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">调仓仓库</div>
                <el-select
                    v-model="searchData.WarehouseId"
                    :loading="loading"
                    class="search-item"
                    size="small"
                    filterable
                    clearable
                    remote
                    :disabled="dataReadonly"
                    @change="warehouseChange"
                    @visible-change="WareHouseVisibleChange($event)"
                >
                    <el-option v-for="optionItem in WarehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId"></el-option>
                </el-select>
                <div class="search-name">调出仓位</div>
                <el-select
                    v-model="searchData.ShelfSpaceId"
                    :disabled="dataReadonly"
                    class="search-item"
                    filterable
                    remote
                    reserve-keyword
                    @change="outSpaceChange"
                    size="small"
                    :remote-method="searchOutPosition"
                    v-select-scroll-more="searchOutPositionLoad"
                    popper-class="el-select-style-gray"
                >
                    <el-option v-for="optionItem in positionList1" :key="optionItem.ShelfSpaceId" :label="optionItem.ShelfSpaceCode" :value="optionItem.ShelfSpaceId"></el-option>
                    <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                </el-select>
                <div class="search-name">——</div>
                <div class="search-name">调入仓位</div>
                <el-select
                    v-model="subData.InGoodsLocationId"
                    :disabled="dataReadonly"
                    class="search-item"
                    :loading="loading"
                    filterable
                    remote
                    reserve-keyword
                    @change="InGoodsLocationChange"
                    size="small"
                    :remote-method="searchInPosition"
                    v-select-scroll-more="searchInPositionLoad"
                    popper-class="el-select-style-gray"
                >
                    <el-option v-for="optionItem in positionList2" :key="optionItem.ShelfSpaceId" :label="optionItem.ShelfSpaceCode" :value="optionItem.ShelfSpaceId"></el-option>
                    <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                </el-select>
                <el-button size="small" class="search-btn btn-primary" @click="save()" v-if="type == 2 || type == 3" :disabled="!canSubmit">保存调仓单</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="saveAndAdd()" v-if="type == 2 || type == 3" :disabled="!canSubmit">保存并继续新增</el-button>
            </div>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">调仓备注</div>
                <el-input class="search-item" size="small" style="width: 890px" v-model="subData.Remark" :readonly="dataReadonly"></el-input>
            </div>
        </div>
        <div v-if="showTable">
            <div class="section-title" v-if="!dataReadonly">
                <div class="sec-item">汽配编码</div>
                <el-input class="sec-item" :disabled="dataReadonly" v-model="searchData.APCode" style="width: 140px" size="small"></el-input>
                <div class="sec-item">汽配分类</div>
                <el-select
                    :disabled="dataReadonly"
                    class="sec-item"
                    size="small"
                    style="width: 140px"
                    v-model="searchData.CateId"
                    remote
                    :remote-method="searchCate"
                    v-select-scroll-more="searchCateLoad"
                    filterable
                    clearable
                    @visible-change="cateVisibleChange($event)"
                    popper-class="el-select-style-gray"
                >
                    <el-option label="全部" value></el-option>
                    <el-option v-for="optionItem in cateList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                        <div class="option-content">
                            <div>{{ optionItem.Text }}</div>
                        </div>
                    </el-option>
                    <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                </el-select>
                <div class="sec-item">汽配品牌</div>
                <el-select
                    class="sec-item"
                    v-model="searchData.BrandName"
                    :disabled="dataReadonly"
                    filterable
                    clearable
                    size="small"
                    style="width: 140px"
                    @visible-change="brandVisibleChange($event)"
                >
                    <el-option label="全部" value></el-option>
                    <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                </el-select>
                <div class="sec-item">
                    <el-button :disabled="dataReadonly" size="small" class="search-btn btn-primary" icon="el-icon-search" @click="handleSearch">筛选</el-button>
                </div>
            </div>
            <div id="infinite-list" :style="{ height: infiniteListHeight + 'px' }">
                <ux-grid
                    ref="infiniteTable"
                    :data="dataList"
                    keep-source
                    :height="infiniteTableHeight"
                    :edit-config="{ trigger: 'click', mode: 'row' }"
                    :row-style="setRowStyle"
                    highlight-current-row
                    show-overflow
                >
                    <ux-table-column field="APCode" title="汽配编码" :edit-render="{ autofocus: '.el-input__inner' }" show-overflow-tooltip resizable>
                        <template v-slot:header="{ column }">
                            <div class="head-view"><span class="color-red">*</span> {{ column.title }}</div>
                        </template>
                        <template v-slot="{ row, rowIndex }">
                            <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle(row.IsNew, rowIndex, 'code')">
                                <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                                <el-tag v-if="row.State == 1 && row.APCode" class="tag" type="warning">已删除</el-tag>
                            </div>
                        </template>
                        <template v-slot:edit="scope">
                            <el-select
                                v-if="!scope.row.APCode"
                                style="width: 100%"
                                :ref="'code' + scope.rowIndex"
                                default-first-option
                                size="small"
                                v-model="scope.row.APCode"
                                value-key="APCode"
                                filterable
                                clearable
                                remote
                                reserve-keyword
                                placeholder="汽配编码"
                                @change="codeChange($event, scope.rowIndex)"
                            >
                                <el-option
                                    v-for="optionItem in codeList"
                                    :key="optionItem.EntpTempGoodsId"
                                    :data-msg="optionItem"
                                    :label="optionItem.APCode"
                                    :value="optionItem.APCode"
                                >
                                    <div class="option-content">
                                        <div class="project-Name">{{ optionItem.APCode }}</div>
                                        <div class="project-Name">{{ optionItem.GoodName }}</div>
                                        <div class="project-Name">
                                            {{ optionItem.AutoSerise }}
                                        </div>
                                    </div>
                                </el-option>
                                <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                            </el-select>
                            <div v-else class="div-padding-12">{{ scope.row.APCode }}</div>
                        </template>
                    </ux-table-column>
                    <ux-table-column field="GoodNameItem" title="配件名称" :edit-render="{ autofocus: '.el-input__inner' }" show-overflow-tooltip resizable>
                        <template v-slot:header="{ column }"> <span class="color-red">*</span> {{ column.title }} </template>
                        <template v-slot="{ row, rowIndex }">
                            <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle(row.IsNew, rowIndex, 'partsNameSelect')">
                                {{ row.GoodNameItem }}
                            </div>
                        </template>
                        <template v-slot:edit="scope">
                            <el-select
                                :disabled="scope.row.APCode != ''"
                                ref="partsNameSelect"
                                style="width: 100%"
                                size="small"
                                v-model="scope.row.GoodName"
                                :title="scope.row.GoodName"
                                value-key="EntpTempGoodsId"
                                filterable
                                clearable
                                remote
                                reserve-keyword
                                placeholder="配件名称"
                                @change="nameChange($event, scope.rowIndex)"
                            >
                                <el-option v-for="optionItem in nameList" :key="optionItem.EntpTempGoodsId" :data-msg="optionItem" :label="optionItem.GoodName" :value="optionItem">
                                    <div class="option-content">
                                        <div class="project-Name">{{ optionItem.GoodName }}</div>
                                        <div class="project-Name">{{ optionItem.APCode }}</div>
                                        <div class="project-Name">
                                            {{ optionItem.AutoSerise }}
                                        </div>
                                    </div>
                                </el-option>
                            </el-select>
                        </template>
                    </ux-table-column>
                    <ux-table-column title="使用车型" field="AutoSerise" show-overflow-tooltip resizable>
                        <template v-slot="{ row }">
                            <div class="div-padding-12">
                                {{ row.AutoSerise }}
                            </div>
                        </template>
                    </ux-table-column>
                    <ux-table-column title="分类" field="Cate" width="120" show-overflow-tooltip resizable>
                        <template v-slot="{ row }">
                            <div class="div-padding-12">
                                {{ row.Cate }}
                            </div>
                        </template>
                    </ux-table-column>
                    <ux-table-column title="品牌" field="Brand" width="120" show-overflow-tooltip resizable>
                        <template v-slot="{ row }">
                            <div class="div-padding-12">
                                {{ row.Brand }}
                            </div>
                        </template>
                    </ux-table-column>
                    <ux-table-column title="单位" field="Unit" width="120" show-overflow-tooltip resizable>
                        <template v-slot="{ row }">
                            <div class="div-padding-12">
                                {{ row.Unit }}
                            </div>
                        </template>
                    </ux-table-column>
                    <ux-table-column title="存放仓库仓位" field="OutGoodsLocationCode" width="150" show-overflow-tooltip resizable>
                        <template v-slot="{ row }">
                            <div class="div-padding-12">
                                {{ row.OutGoodsLocationCode }}
                            </div>
                        </template>
                    </ux-table-column>
                    <ux-table-column title="仓位库存数量" field="OriginalCount" width="150" show-overflow-tooltip resizable>
                        <template v-slot="{ row }">
                            <div class="div-padding-12">
                                {{ row.OriginalCount }}
                            </div>
                        </template>
                    </ux-table-column>
                    <ux-table-column field="Count" title="调出数量" width="100" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                        <template v-slot="{ row }">
                            <div class="div-padding-12">{{ row.Count }}</div>
                        </template>
                        <template v-slot:edit="scope">
                            <div class="sales-input-cell">
                                <el-input-number
                                    type="number"
                                    :ref="'count' + scope.rowIndex"
                                    :disabled="dataReadonly"
                                    :min="1"
                                    :precision="0"
                                    controls-position="right"
                                    size="small"
                                    v-model="scope.row.Count"
                                ></el-input-number>
                            </div>
                        </template>
                    </ux-table-column>
                    <ux-table-column title="操作" width="120" v-if="!dataReadonly" resizable>
                        <template v-slot="{ row, rowIndex }">
                            <div class="operate">
                                <el-button size="small" @click="delItem(rowIndex)" icon="el-icon-delete" v-if="dataList.length !== 1"></el-button>
                                <el-button size="small" type="primary" @click="addItem(true)" icon="el-icon-plus" v-if="rowIndex + 1 === dataList.length && showAddBtn"></el-button>
                            </div>
                        </template>
                    </ux-table-column>
                </ux-grid>
            </div>
        </div>
        <div class="no-data" v-else>请选择调出仓位以新增数据</div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            showAddBtn: false,
            showTable: false,
            type: '',
            pageTitle: '',
            dataReadonly: false,
            loading: false,
            searchData: {
                EntpId: userMsg.EntpId,
                WarehouseId: '',
                ShelfSpaceId: '',
                BrandName: '',
                CateId: '',
                APCode: '',
                GoodName: ''
            },
            subData: {
                UserId: userMsg.EmployeeId,
                ToId: '', // 调拨单id
                WarehouseId: '',
                OutGoodsLocationId: '', // 调出仓位id
                InGoodsLocationId: '',
                Remark: '',
                DetailList: []
            },
            brandList: [],
            cateList: [],
            nameList: [], //这个字段用于保存原仓拥有的商品数据
            codeList: [],
            dataList: [],
            WarehouseList: [],
            positionList1: [],
            positionList2: [],
            permission: {},
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            outPForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            inPForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            infiniteListHeight: 500, // 列表高度 ,
            canSubmit: true
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('warehouse');
        this.type = this.$route.query.type;

        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        if (tablebody) tablebody.addEventListener('click', this.clearActived, false);
        // 监听滚动事件
        window.onresize = () => {
            this.resetHeight();
        };
        if (this.type == 1) {
            this.pageTitle = '查看调仓';
            this.dataReadonly = true;
            this.subData.TOId = this.$route.query.TOId;
            this.getTableData();
        } else if (this.type == 2) {
            this.pageTitle = '编辑调仓';
            this.subData.TOId = this.$route.query.TOId;
            this.getTableData();
        } else if (this.type == 3) {
            this.pageTitle = '新增调仓';
            this.getWarehouse();
        }
        setTimeout(() => {
            this.resetHeight();
        }, 0);
    },
    computed: {
        infiniteTableHeight() {
            let resultHeight = this.infiniteListHeight;
            return resultHeight;
        }
    },
    methods: {
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },

        // 保存调仓单
        save(gotoAdd) {
            let _list = this.dataList;
            if (!this.dataList[0]) {
                this.$util.warningMsg('请添加配件');
                return;
            }
            for (let i = 0; i < _list.length; i++) {
                if (!_list[i].APCode) {
                    this.$util.warningMsg('请选择配件');
                    return;
                }
                if (_list[i].Count > _list[i].OriginalCount) {
                    this.$util.warningMsg('调出数量不得大于库存数量');
                    return;
                }
            }
            this.canSubmit = false;
            this.subData.WarehouseId = this.searchData.WarehouseId;
            this.subData.OutGoodsLocationId = this.searchData.ShelfSpaceId;
            this.subData.DetailList = this.dataList;
            this.subData.UserId = this.userMsg.EmployeeId;
            this.$util
                .axiosPost({
                    url: '/api/EntpTransferOrder/SaveEnterpriseTransferOrder',
                    data: this.subData
                })
                .then(res => {
                    this.$util.successMsg('改仓成功');
                    if (gotoAdd) {
                        this.$router.push(`/inventoryManage/transSpaces/edit?type=3`);
                        this.canSubmit = true;
                        window.location.reload();
                    } else {
                        setTimeout(() => {
                            this.$router.push('/inventoryManage/transSpaces');
                        }, 1000);
                    }
                })
                .catch(() => {
                    this.canSubmit = true;
                });
        },
        // 保存并添加调仓单
        saveAndAdd() {
            this.save(true);
        },
        // 编辑&查看时获取列表
        getTableData() {
            this.dialogVisible = false;
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetEnterpriseTransferOrder',
                    data: {
                        TOId: this.subData.TOId,
                        EntpId: this.userMsg.EntpId,
                        APCode: this.searchData.APCode,
                        BrandName: this.searchData.BrandName,
                        CateId: this.searchData.CateId
                    }
                })
                .then(res => {
                    this.showTable = true;
                    let tablebody = document.querySelector('.elx-table--body-wrapper');
                    if (tablebody) tablebody.addEventListener('click', this.clearActived, false);
                    // 监听滚动事件
                    let data = res.data;
                    if (!data) data = {};
                    //这里这样做是为了防止select控件没有数据，现有绑定值，而导致页面展现出id
                    this.positionList1 = [
                        {
                            ShelfSpaceId: data.OutGoodsLocationId,
                            ShelfSpaceCode: data.OutGoodsLocationCode
                        }
                    ];

                    this.positionList2 = [
                        {
                            ShelfSpaceId: data.InGoodsLocationId,
                            ShelfSpaceCode: data.InGoodsLocationCode
                        }
                    ];
                    this.WarehouseList = [{ WarehouseId: data.OutWarehouseId, WarehouseName: data.OutWarehouseName }];
                    this.subData = data;
                    this.searchData.WarehouseId = data.OutWarehouseId;
                    this.searchData.ShelfSpaceId = data.OutGoodsLocationId;
                    this.dataList = data.DetailList;

                    if (this.type == 1) {
                        this.dataReadonly = true;
                    } else this.searchCode();
                });
        },
        //  调出仓库改变
        warehouseChange(value) {
            if (value) {
                this.searchOutPosition('');
                // this.searchInPosition('');
            } else {
                this.searchData.ShelfSpaceId = '';
                this.subData.InGoodsLocationId = '';
                this.positionList1 = [];
                this.positionList2 = [];
            }
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        //  调出仓位改变
        outSpaceChange(value) {
            if (value) {
                if (value == this.subData.InGoodsLocationId) {
                    this.subData.InGoodsLocationId = '';
                    this.$util.warningMsg('调入仓位和调出仓位不能相同');
                    return;
                }
            }
            if (!this.searchData.ShelfSpaceId) {
                this.$util.warningMsg('请选择仓位');
                return;
            }

            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetEnterpriseFastPartList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    for (let i = 0; i < data.length; i++) {
                        data[i].OriginalCount = data[i].Count;
                    }

                    this.dataList = data;
                    this.codeList = data.concat([]);
                    this.nameList = data.concat([]);

                    this.checkshowAll();
                    this.loading = false;
                });

            setTimeout(() => {
                this.resetHeight();
            }, 0);
        },
        // 调出仓库发生改变时搜仓位
        searchOutPosition(key) {
            if (!this.searchData.WarehouseId) {
                this.$util.warningMsg('请选择仓位');
                return;
            }
            if (![undefined].includes(key)) {
                this.outPForm.Page = 1;
                this.outPForm.stopLoad = false;
                this.outPForm.key = key;
                this.positionList1 = [];
            }
            if (this.outPForm.stopLoad) return;
            this.loading = true;
            this.$util
                .GetShelfSpacesList({
                    WarehouseId: this.searchData.WarehouseId,
                    ShelfSpaceCode: this.outPForm.key,
                    IsLimit: true,
                    Page: this.outPForm.Page,
                    Limit: this.outPForm.Limit
                })
                .then(res => {
                    let data = res.data;
                    this.showTable = true;
                    let tablebody = document.querySelector('.elx-table--body-wrapper');
                    if (tablebody) tablebody.addEventListener('click', this.clearActived, false);

                    this.loading = false;
                    if (data && data.length > 0) {
                        this.searchData.ShelfSpaceId = '';
                        this.outPForm.stopLoad = data.length < this.outPForm.Limit;
                        this.positionList1 = [...this.positionList1, ...data];
                        this.positionList2 = [...this.positionList2, ...data];
                    } else {
                        this.$util.warningMsg('该仓库暂无该编号仓位');
                    }
                });
        },
        searchOutPositionLoad() {
            this.outPForm.Page += 1;
            this.searchOutPosition();
        },
        // 调入仓位发生改变
        InGoodsLocationChange(value) {
            if (value == this.searchData.ShelfSpaceId) {
                this.subData.InGoodsLocationId = '';
                this.$util.warningMsg('调入仓位和调出仓位不能相同');
            }
        },
        // 调入仓库发生改变时搜仓位
        searchInPosition(key) {
            if (!this.searchData.WarehouseId) {
                this.$util.warningMsg('请选择仓位');
                return;
            }
            if (![undefined].includes(key)) {
                this.inPForm.Page = 1;
                this.inPForm.stopLoad = false;
                this.inPForm.key = key;
                this.positionList2 = [];
            }
            if (this.inPForm.stopLoad) return;
            this.loading = true;
            this.$util
                .GetShelfSpacesList({
                    WarehouseId: this.searchData.WarehouseId,
                    ShelfSpaceCode: this.inPForm.key,
                    IsLimit: true,
                    Page: this.inPForm.Page,
                    Limit: this.inPForm.Limit
                })
                .then(res => {
                    let data = res.data;
                    this.loading = false;
                    if (data && data.length > 0) {
                        this.subData.InGoodsLocationId = '';
                        this.inPForm.stopLoad = data.length < this.inPForm.Limit;
                        this.positionList2 = [...this.positionList2, ...data];
                    } else {
                        this.$util.warningMsg('该仓库暂无该编号仓位');
                    }
                });
        },
        searchInPositionLoad() {
            this.inPForm.Page += 1;
            this.searchInPosition();
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse().then(data => {
                this.WarehouseList = data;
            });
        },
        // 名称改变
        nameChange(item, index) {
            if (!item) {
                this.dataList[index].GoodName = '';
            } else if (typeof item == 'string') {
                this.dataList[index].GoodName = item;
            } else {
                // this.dataList[index]= item;
                this.$set(this.dataList, index, item);
            }

            if (this.checkCodeRepeat()) {
                this.checkshowAll();
            } else {
                this.$util.warningMsg('不能选择重复的配件');
                let _data = {
                    EntpTempGoodsId: '',
                    APCode: '',
                    GoodName: '',
                    GoodNameItem: '',
                    AutoSerise: '',
                    Count: '1',
                    OriginalCount: 0,
                    Unit: ''
                };
                this.$set(this.dataList, index, _data);
            }
        },
        // 编码改变
        codeChange(value, index) {
            let _list = this.codeList;
            let _dataList = this.dataList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].APCode == value) {
                    // _dataList[index] = _list[i];
                    this.$set(this.dataList, index, _list[i]);
                    break;
                }
            }
            if (this.checkCodeRepeat()) {
                this.dataList = _dataList;
                this.checkshowAll();
            } else {
                this.$util.warningMsg('不能选择重复的配件');
                let _data = {
                    EntpTempGoodsId: '',
                    APCode: '',
                    GoodName: '',
                    GoodNameItem: '',
                    AutoSerise: '',
                    Count: '1',
                    OriginalCount: 0,
                    Unit: ''
                };
                this.$set(this.dataList, index, _data);
            }
        },
        // 搜索汽配编码
        searchCode(key) {
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetEnterpriseFastPartList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.codeList = res.data;
                    this.nameList = res.data;

                    this.checkshowAll();
                });
        },
        // 添加一行
        addItem() {
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
            }
            this.dataList.push({
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                GoodNameItem: '',
                AutoSerise: '',
                Count: '1',
                OutGoodsLocationCode: '',
                OriginalCount: 0,
                Unit: ''
            });
            this.checkshowAll();
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.checkshowAll();
        },
        // 校验列表是否有重复配件
        checkCodeRepeat() {
            let obj = {};
            let result;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!obj[_dataList[i].APCode]) {
                    obj[_dataList[i].APCode] = [i];
                } else {
                    obj[_dataList[i].APCode].push(i);
                }
            }
            for (let key in obj) {
                if (obj[key].length >= 2) {
                    return false;
                } else {
                    result = true;
                }
            }
            return result;
        },
        // 校验是否已选中全部商品
        checkshowAll() {
            let _target = this.dataList;
            let _origin = this.nameList;
            if (_target.length < _origin.length) {
                this.showAddBtn = true;
                let arr = Array.from(new Set([..._origin].filter(x => !_target.some(y => y.APCode == x.APCode))));
                this.codeList = arr;
            } else {
                this.showAddBtn = false;
            }
        },
        handleSearch() {
            if (this.type * 1 == 2 || this.type * 1 == 1) this.getTableData();
            else if (this.type * 1 == 3) this.outSpaceChange();
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.cateList.length == 0) that.searchCate('');
            }
        },
        searchGoodsBrand() {
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 搜索汽配分类
        searchCate(key) {
            if (![undefined].includes(key)) {
                this.cateForm.Page = 1;
                this.cateForm.stopLoad = false;
                this.cateForm.key = key;
                this.cateList = [];
            }
            if (this.cateForm.stopLoad) return;
            this.loading = true;
            this.$util
                .getEntpApCategoryList(this.cateForm.key, this.cateForm.Page, this.cateForm.Limit)
                .then(data => {
                    this.loading = false;
                    if (!data) return;
                    this.cateForm.stopLoad = data.length < this.cateForm.Limit;
                    this.cateList = [...this.cateList, ...data];
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCateLoad() {
            this.cateForm.Page += 1;
            this.searchCate();
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        // 点击展开下拉框
        focusHandle(isNew, index, type) {
            if (type === 'code' && this.$refs[`code${index}`] && !isNew) {
                setTimeout(() => {
                    this.$refs[`code${index}`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect' && this.$refs[`partsNameSelect`] && !isNew) {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    min-height: 0px;
}
.form-main {
    display: flex;
    > div {
        width: 33.33%;
    }
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: flex-start;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    margin-left: -1px;
    margin-right: 1px;
    background: @border3Color;
}
.sec-item {
    margin-right: 10px;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;
}
.add-btn {
    position: absolute;
    right: -42px;
    bottom: -40px;
    height: 40px;
    width: 40px;
}
.less-btn {
    position: absolute;
    right: -42px;
    top: 5px;
    z-index: 2;
    height: 40px;
    width: 40px;
}
// .business-content-main {
//   padding-right: 80px;
// }
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
}
.history-main {
    position: absolute;
    left: 0;
    width: 100%;
    height: 140px;
    overflow: auto;
    padding: 10px;
    border: 1px solid @border3Color;
    background: white;
    z-index: 2;
    .history-row {
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover {
            background: @border3Color;
        }
        > div {
            text-align: center;
            line-height: 30px;
        }
    }
}
.history-no-data {
    text-align: center;
    font-size: 26px;
    line-height: 100px;
}
.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}
</style>
<style lang="less">
.el-row {
    margin-bottom: 10px;
    &:last-child {
        margin-bottom: 10px;
    }
}
.elx-table {
    .elx-body--row.row--hover,
    .elx-body--row.row--hover.row--stripe {
        background-color: #dcdee1;
    }
    .elx-table--body-wrapper {
        .elx-body--row {
            .table-sort {
                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
            .div-padding-12 {
                padding: 4px 8px 0;
            }
            .div-margin-op {
                display: flex;
                flex-direction: row;
                align-items: center;
            }
            .operate {
                padding: 0 12px;
            }
            td {
                height: 26px;
            }
        }
        .elx-cell {
            padding: 0;
            height: 32px;
        }
        .el-button--small {
            padding: 5px 15px;
            margin: 3px 9px 0 0;
        }
    }
    .elx-table--footer-wrapper {
        margin-top: 0 !important;

        .elx-footer--row {
            .elx-footer--column {
                height: 34px;
            }

            .elx-cell {
                padding: 4px 12px 0;
            }
        }
    }
    .elx-table--body-wrapper {
        padding-bottom: 180px !important;
    }
}
// .infinite-list-special-class {
//   /deep/.elx-table {
//     .elx-table--body-wrapper {
//       padding-bottom: 0 !important;
//     }
//   }
// }
.sales-input-cell {
    .el-input-number {
        width: 100%;
    }
    .el-input {
        .el-input__inner {
            padding-left: 0;
            padding-right: 20px;
        }
    }
    .el-input-number__decrease,
    .el-input-number__increase {
        width: 20px;
    }
}
.unit-input-cell {
    .el-input {
        .el-input__inner {
            padding-right: 20px;
        }
    }
}
.sales-apcode {
    .el-tag {
        height: 24px;
        line-height: 22px;
        margin-left: 8px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
</style>
